import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import { lookupStaffMembers } from './services';
import { userLogout, forbiddenAccess } from './auth';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getSchedulesStart() {
  return {
    type: types.GET_SCHEDULES_START,
  };
}

export function getSchedulesSuccess({ schedules, staffMembers }) {
  return {
    type: types.GET_SCHEDULES_SUCCESS,
    schedules,
    staffMembers,
  };
}

export function getSchedulesFail(ex) {
  return {
    type: types.GET_SCHEDULES_FAIL,
    error: ex.message,
  };
}

export function getSchedules() {
  return (dispatch, getState) => {
    const { business } = getState();
    dispatch(getSchedulesStart());
    (business.id
      ? Promise.resolve(business.id)
      : request
        .get(`${window.Config.API_URL}/business/studioId`)
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then((resp) => {
          return resp.body.data.id;
        })
    )
      .then((businessId) => {
        return Promise.all([
          request
            .get(`${window.Config.API_URL}/business/${businessId}/schedules`)
            .withCredentials()
            .set('X-Request-ID', uuidv4()),
          request
            .get(`${window.Config.API_URL}/business/dental/staffs`)
            .withCredentials()
            .set('X-Request-ID', uuidv4()),
        ]);
      })
      .then((resp) => {
        const schedules = resp[0].body;
        const members = resp[1].body;
        dispatch(
          getSchedulesSuccess({
            staffMembers: members,
            schedules: (schedules || []).map((schedule) => {
              return {
                ...schedule,
                start: schedule.slot.start,
                end: schedule.slot.end,
                staff: lookupStaffMembers(schedules.staff_ids, members),
              };
            }),
          }),
        );
      })
      .catch((ex) => {
        dispatch(getSchedulesFail(ex));
      });
  };
}

export function saveSchedule(schedule) {
  return (dispatch, getState) => {
    dispatch(getSchedulesStart());
    const { schedules, business } = getState();
    const obj = {
      id: schedule.id || uuidv4(),
      business_id: business.id,
      day: schedule.day,
      slot: {
        start: schedule.start,
        end: schedule.end,
      },
      type: schedule.type,
      staff_ids: schedule.staff_ids || [],
    };
    (schedule.id
      ? request
        .put(
          `${window.Config.API_URL}/business/${business.id}/schedules/${schedule.id}`,
        )
        .withCredentials()
        .set('X-Request-ID', uuidv4())
      : request
        .post(`${window.Config.API_URL}/business/${business.id}/schedules`)
        .withCredentials()
        .set('X-Request-ID', uuidv4())
    )
      .send(obj)
      .then(() => {
        obj.start = obj.slot.start;
        obj.end = obj.slot.end;
        obj.staff = lookupStaffMembers(obj.staff_ids, schedules.staffMembers);
        if (schedule.id) {
          const idx = schedules.list.findIndex((m) => {
            return m.id === schedule.id;
          });
          schedules.list[idx] = obj;
        } else {
          schedules.list.push(obj);
        }
        dispatch(
          getSchedulesSuccess({
            schedules: schedules.list,
            staffMembers: schedules.staffMembers,
          }),
        );
      })
      .catch((ex) => {
        dispatch(getSchedulesFail(ex));
      });
  };
}

export function removeSchedule(id) {
  return (dispatch, getState) => {
    dispatch(getSchedulesStart());
    const { schedules, business } = getState();
    const idx = schedules.list.findIndex((m) => {
      return m.id === id;
    });
    if (idx !== -1) {
      request
        .delete(
          `${window.Config.API_URL}/business/${business.id}/schedules/${id}`,
        )
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then(() => {
          schedules.list.splice(idx, 1);
          dispatch(
            getSchedulesSuccess({
              schedules: schedules.list,
              staffMembers: schedules.staffMembers,
            }),
          );
        })
        .catch((ex) => {
          dispatch(getSchedulesFail(ex));
        });
    }
  };
}

export function getDentalSchedulesStart() {
  return {
    type: types.GET_DENTAL_SCHEDULES_START,
  };
}

export function getDentalSchedulesSuccess({ availability, schedule }) {
  return {
    type: types.GET_DENTAL_SCHEDULES_SUCCESS,
    availability,
    schedule,
  };
}

export function getDentalSchedulesFail(ex) {
  return {
    type: types.GET_DENTAL_SCHEDULES_FAIL,
    error: ex.message,
  };
}

export function getDentalSchedules(data) {
  return (dispatch) => {
    dispatch(getDentalSchedulesStart());
    const ret = {};
    Promise.all([
      request
        .post(
          `${window.Config.API_URL}/business/calendar/${data.business_id}/availability`,
        )
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .send(data)
        .then((res) => {
          ret.availability = res.body;
        }),
      request
        .post(
          `${window.Config.API_URL}/business/calendar/${data.business_id}/schedules`,
        )
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .send(data)
        .then((res) => {
          ret.schedule = res.body;
        }),
    ])
      .then(() => {
        console.log('Response', ret);
        dispatch(getDentalSchedulesSuccess(ret));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(getDentalSchedulesFail(ex));
      });
  };
}

export function getDentalBooking(data) {
  return (dispatch) => {
    dispatch(getDentalSchedulesStart());
    request
      .post(
        `${window.Config.API_URL}/business/calendar/${data.business_id}/schedules`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        console.log('Response', resp);
        const ret = {
          availability: [],
          schedule: resp.body,
        };
        dispatch(getDentalSchedulesSuccess(ret));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(getDentalSchedulesFail(ex));
      });
  };
}

export function getProcedureCodes(data) {
  return (dispatch) => {
    dispatch(getProcedureCodesStart());
    request
      .get(
        `${window.Config.API_URL}/business/calendar/${data.business_id}/location/${data.location_id}/appointment_descriptor_ids`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log('Response', resp);
        dispatch(getProcedureCodesSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(getProcedureCodesFail(ex));
      });
  };
}

export function getProcedureCodesStart() {
  return {
    type: types.GET_PROCEDURE_CODES_START,
  };
}

export function getProcedureCodesSuccess(procedure_codes) {
  return {
    type: types.GET_PROCEDURE_CODES_SUCCESS,
    procedure_codes,
  };
}

export function getProcedureCodesFail(ex) {
  return {
    type: types.GET_PROCEDURE_CODES_FAIL,
    error: ex.message,
  };
}

export function getServiceTypeDetailsStart() {
  return {
    type: types.GET_SERVICE_TYPE_DETAILS_START,
  };
}

export function getServiceTypeDetailsSuccess(serviceTypeDetails) {
  return {
    type: types.GET_SERVICE_TYPE_DETAILS_SUCCESS,
    serviceTypeDetails,
  };
}

export function getServiceTypeDetailsFail(ex) {
  return {
    type: types.GET_SERVICE_TYPE_DETAILS_FAIL,
    error: ex.message,
  };
}

export function getServiceTypeDetails(business_id) {
  return (dispatch) => {
    dispatch(getServiceTypeDetailsStart());
    request
      .get(
        `${window.Config.API_URL}/business/service_agent/${business_id}/service_list`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        const serviceTypeDetails =
          resp?.body?.service_list || resp?.body?.data || resp?.body || [];
        dispatch(getServiceTypeDetailsSuccess(serviceTypeDetails));
      })
      .catch((ex) => {
        dispatch(getServiceTypeDetailsFail(ex));
      });
  };
}

export function addServiceTypes(data) {
  return (dispatch) => {
    dispatch(addServiceStart());
    const isDummyServiceRequest = !!data.serviceAgentBody;
    const shouldCreateServiceAgentRecord = !!data.serviceAgentBodyTemplate;
    const requestBuilder = isDummyServiceRequest
      ? request.post(
        `${window.Config.API_URL}/business/service_agent/${data.serviceAgentBody.business_id}/service_list`,
      )
      : request.post(
        `${window.Config.API_URL}/business/calendar/${data.business_id}/location/${data.location_id}/service`,
      );

    requestBuilder
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(isDummyServiceRequest ? data.serviceAgentBody : data.body)
      .then((resp) => {
        console.log('Response', resp);
        const dummyPayloadService = data?.serviceAgentBody?.services?.[0] || {};
        const fallbackDurationMinutes = Number(data?.body?.minutes || 5);
        const responseBody = resp?.body || {};
        const createdService = isDummyServiceRequest
          ? {
            ...responseBody,
            name: data?.body?.name || dummyPayloadService?.friendly_name || '',
            duration:
              responseBody?.duration ||
              `PT${fallbackDurationMinutes}M`,
            steps: data?.body?.steps || [],
            kind: responseBody?.kind || 'SESSION',
            service_id: dummyPayloadService?.service_id || '',
            category_id: dummyPayloadService?.category_id || '',
            friendly_name: dummyPayloadService?.friendly_name || '',
            friendly_description:
              dummyPayloadService?.friendly_description || '',
            block_type:
              responseBody?.block_type ||
              dummyPayloadService?.block_type ||
              'DUMMY_BLOCKED',
            manual_block:
              responseBody?.manual_block === undefined
                ? true
                : !!responseBody?.manual_block,
            id:
              responseBody?.id ||
              responseBody?.service_id ||
              dummyPayloadService?.service_id,
          }
          : resp.body;
        if (!isDummyServiceRequest && shouldCreateServiceAgentRecord) {
          const serviceAgentPayloadTemplate = data.serviceAgentBodyTemplate;
          const serviceAgentPayload = {
            category_id:
              resp?.body?.ancestor_id ||
              serviceAgentPayloadTemplate?.category_id ||
              '',
            category_name:
              resp?.body?.ancestor_name ||
              serviceAgentPayloadTemplate?.category_name ||
              '',
            service_id:
              resp?.body?.id || serviceAgentPayloadTemplate?.service_id || '',
            friendly_name: serviceAgentPayloadTemplate?.friendly_name || '',
            friendly_description:
              serviceAgentPayloadTemplate?.friendly_description || '',
            kind: serviceAgentPayloadTemplate?.kind || 'SESSION',
            block_type: serviceAgentPayloadTemplate?.block_type || 'NONE',
            manual_block: !!serviceAgentPayloadTemplate?.manual_block,
          };

          return request
            .post(
              `${window.Config.API_URL}/business/service_agent/${serviceAgentPayloadTemplate.business_id}/service_list`,
            )
            .withCredentials()
            .set('X-Request-ID', uuidv4())
            .send({
              business_id: serviceAgentPayloadTemplate.business_id,
              updated_by: serviceAgentPayloadTemplate.updated_by,
              services: [serviceAgentPayload],
            })
            .then(() => {
              dispatch(addServiceSuccess(createdService));
            });
        }

        dispatch(addServiceSuccess(createdService));
        return null;
      })
      .catch((ex) => {
        console.log('Response ex');
        const errorMessage = ex?.response?.body;
        dispatch(addServiceFail(errorMessage));
      });
  };
}

export function addServiceStart() {
  return {
    type: types.ADD_SERVICE_TYPES_START,
  };
}

export function addServiceSuccess(service) {
  return {
    type: types.ADD_SERVICE_TYPES_SUCCESS,
    service,
  };
}

export function addServiceFail(ex) {
  return {
    type: types.ADD_SERVICE_TYPES_FAIL,
    error: ex.message,
  };
}

export function editServiceTypes(data) {
  return (dispatch) => {
    dispatch(editServiceStart());
    const isServiceAgentUpdate = Array.isArray(data?.body?.services);
    const requestBuilder = isServiceAgentUpdate
      ? request.put(
        `${window.Config.API_URL}/business/service_agent/${data.body.business_id}/service_list`,
      )
      : request.put(
        `${window.Config.API_URL}/business/calendar/${data.business_id}/location/${data.location_id}/service/${data.service_id}`,
      );

    requestBuilder
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data.body)
      .then((resp) => {
        console.log('Response', resp);
        const updatedService = {
          ...(data.service || {}),
          ...(resp?.body || {}),
          id: data.service_id || data?.service?.id,
        };
        dispatch(editServiceSuccess(updatedService));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        const errorMessage = ex?.response?.body;
        dispatch(editServiceFail(errorMessage));
      });
  };
}

export function editServiceStart() {
  return {
    type: types.EDIT_SERVICE_TYPES_START,
  };
}

export function editServiceSuccess(service) {
  return {
    type: types.EDIT_SERVICE_TYPES_SUCCESS,
    service,
  };
}

export function editServiceFail(ex) {
  return {
    type: types.EDIT_SERVICE_TYPES_FAIL,
    error: ex.message,
  };
}

export function deleteServiceTypes(data) {
  return (dispatch) => {
    dispatch(deleteServiceStart());
    const isDummyBlocked = data.block_type === 'DUMMY_BLOCKED';
    const requestBuilder = isDummyBlocked
      ? request
        .delete(
          `${window.Config.API_URL}/business/service_agent/${data.business_id}/service_list`,
        )
      : request
        .delete(
          `${window.Config.API_URL}/business/calendar/${data.business_id}/location/${data.location_id}/service/${data.service_id}`,
        );

    requestBuilder
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(
        isDummyBlocked
          ? {
            business_id: data.business_id,
            updated_by: data.updated_by,
            service_id: data.service_id,
          }
          : data.body,
      )
      .ok((resp) => resp.status < 401)
      .then((resp) => {
        console.log('Response', resp);
        if (resp.status >= 200 && resp.status < 300) {
          // If the response status code is 2xx, handle it as success
          console.log('Response', resp);
          dispatch(
            deleteServiceSuccess({
              ...(resp?.body || {}),
              id: resp?.body?.id || data.service_id,
            }),
          );
        } else {
          // If the response status code is not 2xx, treat it as an error
          console.log('Response error', resp);
          const errorMessage = resp?.body;
          dispatch(deleteServiceFail(errorMessage));
        }
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(deleteServiceFail(ex));
      });
  };
}

export function deleteServiceStart() {
  return {
    type: types.DELETE_SERVICE_TYPES_START,
  };
}

export function deleteServiceSuccess(service) {
  return {
    type: types.DELETE_SERVICE_TYPES_SUCCESS,
    service,
  };
}

export function deleteServiceFail(ex) {
  return {
    type: types.DELETE_SERVICE_TYPES_FAIL,
    error: ex.message,
  };
}

export function syncServiceTypes(business_id) {
  return (dispatch) => {
    dispatch(syncServiceStart());
    request
      .post(`${window.Config.API_URL}/business/calendar/sync`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({ business_ids: [business_id] })
      .then((resp) => {
        console.log('Response', resp);
        dispatch(syncServiceSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(syncServiceFail(ex));
      });
  };
}

export function updateServiceMappingsAPI(client_id, service_mapping) {
  return (dispatch) => {
    dispatch(updateServiceMappingsStart());
    request
      .post(`${window.Config.API_URL}/business/dental/internal/preferences/service_mapping`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({ client_id, service_mapping })
      .then((resp) => {
        console.log('Response', resp);
        dispatch(updateServiceMappingsSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(updateServiceMappingsFail(ex));
      });
  };
}

export function syncServiceStart() {
  return {
    type: types.SYNC_BUSINESS_START,
  };
}

export function syncServiceSuccess(service) {
  return {
    type: types.SYNC_BUSINESS_SUCCESS,
    service,
  };
}

export function syncServiceFail(ex) {
  return {
    type: types.SYNC_BUSINESS_FAIL,
    error: ex.message,
  };
}

export function updateServiceMappingsStart() {
  return {
    type: types.UPDATE_SERVICE_MAPPING_START,
  };
}

export function updateServiceMappingsSuccess() {
  return {
    type: types.UPDATE_SERVICE_MAPPING_SUCCESS,
  };
}

export function updateServiceMappingsFail(ex) {
  return {
    type: types.UPDATE_SERVICE_MAPPING_FAIL,
    error: ex.message,
  };
}

export function storeService(services) {
  return (dispatch) => {
    dispatch({
      type: types.STORE_SERVICE_TYPES,
      services,
    });
  };
}

export function clearServiceFlags() {
  return (dispatch) => {
    dispatch({
      type: types.CLEAR_SERVICE_TYPES_FLAG,
    });
  };
}

export function getSchedule(data) {
  return (dispatch) => {
    dispatch(getScheduleStart());
    const ret = {};
    Promise.all([
      request
        .get(
          `${window.Config.API_URL}/business/staff_schedule/${data.business_id}/location/${data.location_id}`,
        )
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then((res) => {
          ret.staff_schedule = res.body;
        }),
      request
        .get(
          `${window.Config.API_URL}/business/un_synced_staffs/${data.business_id}/location/${data.location_id}`,
        )
        .set('X-Request-ID', uuidv4())
        .then((res) => {
          ret.staff_list = res.body;
        }),
    ])
      .then(() => {
        console.log('Response', ret);
        dispatch(getScheduleSuccess(ret));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(getScheduleFail(ex));
      });
  };
}

export function getScheduleStart() {
  return {
    type: types.GET_SCHEDULE_DEFINITION_START,
  };
}

export function getScheduleSuccess(scheduleDefinition) {
  return {
    type: types.GET_SCHEDULE_DEFINITION_SUCCESS,
    scheduleDefinition,
  };
}

export function getScheduleFail(ex) {
  return {
    type: types.GET_SCHEDULE_DEFINITION_FAIL,
    error: ex.message,
  };
}

export function addSchedule({ data, business_id }) {
  return (dispatch) => {
    dispatch(addScheduleStart());
    request
      .post(`${window.Config.API_URL}/business/staff_schedule/${business_id}`)
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        console.log('Response', resp);
        dispatch(addScheduleSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(addScheduleFail(ex));
      });
  };
}

export function editScheduleAPI({ data, business_id }) {
  return (dispatch) => {
    dispatch(addScheduleStart());
    request
      .patch(`${window.Config.API_URL}/business/staff_schedule/${business_id}`)
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        console.log('Response', resp);
        dispatch(addScheduleSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(addScheduleFail(ex));
      });
  };
}

export function addScheduleStart() {
  return {
    type: types.ADD_DEFINITION_START,
  };
}

export function addScheduleSuccess(scheduleDefinition) {
  return {
    type: types.ADD_DEFINITION_SUCCESS,
    scheduleDefinition,
  };
}

export function addScheduleFail(ex) {
  return {
    type: types.ADD_DEFINITION_FAIL,
    error: ex.message,
  };
}

export function deleteScheduleAPI({ data, business_id }) {
  return (dispatch) => {
    dispatch(deleteScheduleStart());
    request
      .delete(`${window.Config.API_URL}/business/staff_schedule/${business_id}`)
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        console.log('Response', resp);
        dispatch(deleteScheduleSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(deleteScheduleFail(ex));
      });
  };
}

export function deleteScheduleStart() {
  return {
    type: types.DELETE_DEFINITION_START,
  };
}

export function deleteScheduleSuccess(data) {
  return {
    type: types.DELETE_DEFINITION_SUCCESS,
    data,
  };
}

export function deleteScheduleFail(ex) {
  return {
    type: types.DELETE_DEFINITION_FAIL,
    error: ex.message,
  };
}

export function getBlockRules(data) {
  return (dispatch) => {
    dispatch(getBlockRulesStart());
    request
      .get(
        `${window.Config.API_URL}/business/rules_metadata/${data.business_id}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log('Response', resp);
        dispatch(getBlockRulesSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(getBlockRulesFail(ex));
      });
  };
}

export function getBlockRulesStart() {
  return {
    type: types.GET_BLOCK_RULES_START,
  };
}

export function getBlockRulesSuccess(blockRules) {
  return {
    type: types.GET_BLOCK_RULES_SUCCESS,
    blockRules,
  };
}

export function getBlockRulesFail(ex) {
  return {
    type: types.GET_BLOCK_RULES_FAIL,
    error: ex.message,
  };
}

export function addBlockRules(data) {
  return (dispatch) => {
    dispatch(addBlockRulesStart());
    request
      .post(`${window.Config.API_URL}/business/rules_metadata`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        console.log('Response', resp);
        dispatch(addBlockRulesSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(addBlockRulesFail(ex));
      });
  };
}

export function addBlockRulesStart() {
  return {
    type: types.ADD_BLOCK_RULES_START,
  };
}

export function addBlockRulesSuccess(blockRules) {
  return {
    type: types.ADD_BLOCK_RULES_SUCCESS,
    blockRules,
  };
}

export function addBlockRulesFail(ex) {
  return {
    type: types.ADD_BLOCK_RULES_FAIL,
    error: ex.message,
  };
}

export function updateBlockRules(data) {
  return (dispatch) => {
    dispatch(updateBlockRulesStart());
    request
      .patch(`${window.Config.API_URL}/business/rules_metadata`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        console.log('Response', resp);
        dispatch(updateBlockRulesSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(updateBlockRulesFail(ex));
      });
  };
}

export function updateBlockRulesStart() {
  return {
    type: types.UPDATE_BLOCK_RULES_START,
  };
}

export function updateBlockRulesSuccess(blockRules) {
  return {
    type: types.UPDATE_BLOCK_RULES_SUCCESS,
    blockRules,
  };
}

export function updateBlockRulesFail(ex) {
  return {
    type: types.UPDATE_BLOCK_RULES_FAIL,
    error: ex.message,
  };
}

export function deleteBlockRules(data) {
  return (dispatch) => {
    dispatch(deleteBlockRulesStart());
    request
      .delete(
        `${window.Config.API_URL}/business/rules_metadata/${data.rule_id}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data.body)
      .then((resp) => {
        console.log('Response', resp);
        dispatch(
          deleteBlockRulesSuccess({ resp: resp.body, rule_id: data.rule_id }),
        );
      })
      .catch((ex) => {
        console.log('Response ex', ex);
        dispatch(deleteBlockRulesFail(ex));
      });
  };
}

export function deleteBlockRulesStart() {
  return {
    type: types.DELETE_BLOCK_RULES_START,
  };
}

export function deleteBlockRulesSuccess(blockRules) {
  return {
    type: types.DELETE_BLOCK_RULES_SUCCESS,
    blockRules,
  };
}

export function deleteBlockRulesFail(ex) {
  return {
    type: types.DELETE_BLOCK_RULES_FAIL,
    error: ex.message,
  };
}
